/**
 * Service: Auth
 * Wraps Supabase Auth operations.
 * Note: auth-context.tsx already acts as a React wrapper;
 * this module provides the raw functions for portability.
 */
import { supabase } from "@/integrations/supabase/client";

export async function signInWithPassword(email: string, password: string) {
  const { error } = await supabase.auth.signInWithPassword({ email, password });
  return { error: error?.message ?? null };
}

export async function signInWithMagicLink(email: string) {
  const { error } = await supabase.auth.signInWithOtp({
    email,
    options: { emailRedirectTo: window.location.href.split('#')[0] },
  });
  return { error: error?.message ?? null };
}

export async function signUp(email: string, password: string) {
  // Redirect back to the CURRENT page (not root) so wizard state is preserved
  const { error } = await supabase.auth.signUp({
    email,
    password,
    options: { emailRedirectTo: window.location.href.split('#')[0] },
  });
  return { error: error?.message ?? null };
}

export async function signOut() {
  await supabase.auth.signOut();
}

export async function getUser() {
  return supabase.auth.getUser();
}

export async function getSession() {
  return supabase.auth.getSession();
}

export function onAuthStateChange(callback: Parameters<typeof supabase.auth.onAuthStateChange>[0]) {
  return supabase.auth.onAuthStateChange(callback);
}
